/**
 * Main Product Section JavaScript
 * Handles quantity controls, responsive Slick gallery, and AJAX add to cart
 */

document.addEventListener('DOMContentLoaded', function () {
  // Quantity Controls
  const quantityInput = document.querySelector('[data-quantity-input]');
  const minusBtn = document.querySelector('.main-product__quantity-btn--minus');
  const plusBtn = document.querySelector('.main-product__quantity-btn--plus');

  if (minusBtn && plusBtn && quantityInput) {
    minusBtn.addEventListener('click', function () {
      const currentValue = parseInt(quantityInput.value) || 1;
      if (currentValue > 1) {
        quantityInput.value = currentValue - 1;
      }
    });

    plusBtn.addEventListener('click', function () {
      const currentValue = parseInt(quantityInput.value) || 1;
      quantityInput.value = currentValue + 1;
    });
  }

  // AJAX Add to Cart
  const productForm = document.querySelector('[data-product-form]');

  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();

      const addButton = productForm.querySelector('[data-add-to-cart]');
      const buttonText = addButton.querySelector('[data-button-text]');
      const errorMessage = productForm.querySelector('[data-error-message]');
      const variantId = productForm.querySelector('[data-variant-id]').value;
      const quantity = productForm.querySelector('[data-quantity-input]').value;

      // Store original button text
      const originalText = buttonText.textContent;

      // Disable button and show loading state
      addButton.disabled = true;
      buttonText.textContent = 'Adding...';
      errorMessage.textContent = '';
      errorMessage.style.display = 'none';

      // Get cart drawer section ID for bundled rendering
      const cartDrawer = document.getElementById('cart-drawer');
      let sectionId = 'cart-drawer'; // Default fallback
      if (cartDrawer) {
        const wrapper = cartDrawer.parentElement;
        if (wrapper && wrapper.id && wrapper.id.startsWith('shopify-section-')) {
          sectionId = wrapper.id.replace('shopify-section-', '');
        } else {
          const closestWrapper = cartDrawer.closest('[id^="shopify-section-"]');
          if (closestWrapper) {
            sectionId = closestWrapper.id.replace('shopify-section-', '');
          }
        }
      }

      // Prepare form data with bundled section rendering
      const formData = {
        items: [{
          id: parseInt(variantId),
          quantity: parseInt(quantity)
        }],
        sections: sectionId  // Request cart drawer HTML via bundled section rendering
      };

      // Add to cart via Shopify AJAX Cart API with bundled section rendering
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      })
        .then(response => {
          if (!response.ok) {
            return response.json().then(err => Promise.reject(err));
          }
          return response.json();
        })
        .then(data => {
          // Success - update button text temporarily
          buttonText.textContent = 'Added!';

          // Fetch full cart data (cart/add.js only returns added items)
          return fetch(window.Shopify.routes.root + 'cart.js')
            .then(response => response.json())
            .then(cart => {
              // Dispatch custom event with bundled section HTML and full cart data
              document.dispatchEvent(new CustomEvent('cart:updated', {
                detail: {
                  cart: cart,
                  addedItems: data.items,
                  sections: data.sections || null  // Include rendered HTML if available
                }
              }));

              // Reset button after 2 seconds
              setTimeout(() => {
                buttonText.textContent = originalText;
                addButton.disabled = false;
              }, 2000);
            });
        })
        .catch(error => {
          // Error handling - Shopify returns specific error messages
          console.error('Error adding to cart:', error);

          let errorMsg = 'Unable to add to cart. Please try again.';

          // Handle Shopify's error format
          if (error.description) {
            errorMsg = error.description;
          } else if (error.message) {
            errorMsg = error.message;
          }

          errorMessage.textContent = errorMsg;
          errorMessage.style.display = 'block';

          // Reset button
          buttonText.textContent = originalText;
          addButton.disabled = false;
        });
    });
  }


  const productForms = document.querySelectorAll('[data-product-form]');

  productForms.forEach((form) => {
    const variantSelect = form.querySelector('[data-variant-select]');
    const hiddenVariantInput = form.querySelector('[data-variant-id]');
    const priceInButton = form.querySelector('[data-price-in-button]');
    const addButton = form.querySelector('[data-add-to-cart]');
    const buttonText = addButton && addButton.querySelector('[data-button-text]');

    if (!variantSelect || !hiddenVariantInput || !priceInButton || !addButton || !buttonText) {
      return;
    }

    const addText = buttonText.dataset.buttonTextAdd || 'Add to cart';
    const soldOutText = buttonText.dataset.buttonTextSoldOut || 'Sold out';
    const currency = priceInButton.dataset.currency || 'USD';

    const formatMoney = (cents) => {
      const amount = Number(cents || 0) / 100;
      return amount.toLocaleString(undefined, {
        style: 'currency',
        currency,
      });
    };

    const updateForVariant = (variantId) => {
      const option = variantSelect.querySelector(`option[value="${CSS.escape(variantId)}"]`);
      if (!option) return;

      const priceCents = Number(option.dataset.price || 0);
      const available = option.dataset.available === 'true';

      // Update hidden id input so form & AJAX use the correct variant
      hiddenVariantInput.value = variantId;

      // Update button price text
      priceInButton.textContent = formatMoney(priceCents);

      // Update button state and text
      if (available) {
        addButton.disabled = false;
        buttonText.textContent = addText;
      } else {
        addButton.disabled = true;
        buttonText.textContent = soldOutText;
      }
    };

    // Initial sync
    updateForVariant(variantSelect.value);

    variantSelect.addEventListener('change', () => {
      updateForVariant(variantSelect.value);
    });
  });

  const layoutBreakpoint = 767;
  const DesktopBreakpoint = 1199;

  // Initialize Slick Gallery (responsive)
  const $gallery = $('.js-product-slider');

  if ($gallery.length && typeof $.fn.slick !== 'undefined') {
    $gallery.slick({
      dots: true,
      arrows: false,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: false,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: layoutBreakpoint,
          settings: 'unslick' // Disable Slick on desktop (768px and above)
        }
      ]
    });

    // Handle window resize to re-initialize if needed
    let resizeTimer;
    $(window).on('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if ($(window).width() <= layoutBreakpoint) {
          // Re-initialize Slick on mobile if it was unslicked
          if (!$gallery.hasClass('slick-initialized')) {
            $gallery.slick({
              dots: true,
              arrows: false,
              infinite: true,
              speed: 300,
              slidesToShow: 1,
              slidesToScroll: 1,
              adaptiveHeight: false
            });
          }
        } else {
          // Unslick on desktop if initialized
          if ($gallery.hasClass('slick-initialized')) {
            $gallery.slick('unslick');
          }
        }
      }, 250);
    });
  }

  // Initialize Slick Lightbox (Desktop only - above 1199px)
  const lightboxGallery = document.querySelector('[data-lightbox="product-gallery"]');
  if (lightboxGallery && typeof jQuery !== 'undefined' && jQuery.fn.slickLightbox) {
    let lightboxInitialized = false;

    const initLightbox = () => {
      if (window.innerWidth > DesktopBreakpoint && !lightboxInitialized) {
        lightboxInitialized = true;
        jQuery(lightboxGallery).slickLightbox({
          itemSelector: '.main-product__gallery-link',
          background: 'var(--base-off-white)',
          slick: {
            dots: true,
            arrows: true,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: false,
          }
        }).on('shown.slickLightbox', () => {
          const lightboxContainer = document.querySelector('.slick-lightbox');
          if (lightboxContainer) {
            console.log('lightboxContainer', lightboxContainer);
            window.lightboxFocusTrap = window.BellavoraFocusTrap.initFocusTrap(lightboxContainer, { active: true });
          }
        }).on('hidden.slickLightbox', () => {
          if (window.lightboxFocusTrap) {
            console.log('hidden.slickLightbox');
            window.lightboxFocusTrap.deactivate();
            window.lightboxFocusTrap = null;
          }
        });
      }
    };

    initLightbox();

    // Only initialize once; no need to re-init on resize
    let lightboxResizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(lightboxResizeTimer);
      lightboxResizeTimer = setTimeout(initLightbox, 250);
    });
  }
});
